import { makeStyles } from "@material-ui/core"

export const mechanicalWorkTaskStyle = makeStyles(theme => ({
    labelRed: {
        backgroundColor: "red",
        borderRadius: 10,
        padding: "4px 8px",
        color: "white",
        marginLeft: '8px'
    },
    icon: {
        fontSize: '200%',
        marginRight: "8px",
        width: '24',
        height: '24',
    },
    iconDark: {
        fontSize: '500%',
        fill: '#000',
        marginRight: '-3rem',
    },
    card: {
        margin: '0.75rem 0',
        padding: '1.5rem',
    },
    gridCard: {
        margin: 0,
        padding: '1.5rem',
        height: '100%',
        boxSizing: 'border-box',
    },
    flexCard: {
        display: 'flex',
        flexDirection: 'column',
    },
    stepsInventoryBody: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        margin: 0,
        width: '100%',
        maxWidth: '100%',
        padding: '0 0.5rem',
        boxSizing: 'border-box',
    },
    compactCard: {
        '& .MuiInputBase-root': {
            fontSize: 13,
        },
        '& .MuiInputBase-input': {
            fontSize: 13,
        },
        '& .MuiInputLabel-root, & .MuiFormLabel-root': {
            fontSize: 13,
            fontFamily: theme.typography.fontFamily,
        },
        '& .MuiInputLabel-outlined:not(.MuiInputLabel-shrink)': {
            transform: 'translate(14px, 11px) scale(1)',
        },
        '& .MuiOutlinedInput-root': {
            minHeight: 38,
            height: 38,
            paddingTop: 0,
            paddingBottom: 0,
            alignItems: 'center',
        },
        '& .MuiAutocomplete-root': {
            paddingTop: '0 !important',
            paddingBottom: '0 !important',
        },
        '& .MuiOutlinedInput-input': {
            paddingTop: 0,
            paddingBottom: 0,
        },
        '& .MuiButton-root': {
            fontSize: 13,
        },
        '& .MuiFormControlLabel-label': {
            fontSize: 13,
        },
        '& .MuiCheckbox-root .MuiSvgIcon-root': {
            fontSize: 20,
        },
    },
    noteCard: {
        backgroundColor: '#fbfaff',
    },
    titleRow: {
        marginBottom: "32px"
    },
    title: {
        margin: 0,
        padding: 0,
        fontWeight: 500,
        marginRight: "8px",
        color: theme.typography.color
    },
    detailLabel: {
        marginRight: "5px",
        fontWeight: 600,
    },
    headerDevider: {
        marginTop: '1.5rem'
    },
    dateInfo: {
        marginRight: 8
    },
    dateIn: {
        color: theme.palette.success.dark
    },
    dateOut: {
        color: theme.palette.error.dark
    },
    details: {
        color: theme.palette.secondary.light,
        fontSize: 15,
        maxWidth: "1200px",
        "&:not(:last-child)": {
            marginBottom: "20px"
        }
    },
    stepsAndInventory: {
        color: theme.palette.secondary.light,
        fontSize: 16,
        maxWidth: "900px",
        "&:not(:last-child)": {
            marginBottom: "20px"
        },
        display: "flex"
    },
    detail: {
        marginRight: '2rem',
        marginLeft: '1rem',
        "&:not(:first-child)": {

        },
    },
    vehicleDetail: {
        display: 'flex',
    },
    vehicleDetailLabel: {
        marginRight: '4px',
    },
    maintenance: {
        fontSize: 16,
        color: theme.palette.secondary.light,
        marginBottom: -16
    },
    maintenanceField: {
        position: "relative",
        minWidth: 268,
        marginBottom: 16,
        paddingLeft: 16,
        "&:not(:first-child)": {
            "&::before": {
                content: "''",
                width: 2,
                height: "100%",
                background: theme.palette.neutral.main,
                position: "absolute",
                top: 0,
                left: 0,
            }
        }
    },
    bordered: {
        position: "relative",
        minWidth: 268,
        marginBottom: 16,
        "&:not(:first-child)": {
            paddingLeft: 16,
            "&::before": {
                content: "''",
                width: 2,
                height: "100%",
                background: theme.palette.neutral.main,
                position: "absolute",
                top: 0,
                left: 0,
            }
        }
    },
    maintenanceDetail: {
        fontSize: 20,
        color: theme.typography.color
    },
    parkingDetail: {
        marginBottom: 8,
    },
    imageDeleteIcon: {
        position: "absolute",
        bottom: 0,
        left: 0,
        opacity: 0,
        transition: "opacity 0.5s ease",
    },
    imageContainer: {
        position: "relative",
        width: 223,
        maxWidth: '100%',
        height: 120,
        margin: "0 1rem 1rem 0",
        borderRadius: 4,
        overflow: "hidden",
        "&:hover": {
            "& $imageDeleteIcon": {
                opacity: 1,
            }
        }
    },
    fileName: {
        position: "absolute",
        left: '50%',
        bottom: '4px',
        fontSize: 12,
        opacity: 0.6,
        transform: 'translateX(-50%)',
        whiteSpace: 'nowrap',
        borderRadius: '2px',
        padding: '2px',
        color: theme.palette.primary.main,
        fontWeight: 500
    },
    image: {
        position: "absolute",
        top: 0,
        left: 0,
        height: '100%',
        width: '100%',
        opacity: 0,
        transition: "opacity 1s ease",
        objectFit: "cover"
    },
    imagePreviewWrapper: {
        height: '120px',
        marginTop: '10px',
        '& img': {
            //objectFit: 'contain',
            position: 'initial'
        }
    },
    placeholder: {
        height: '100%',
        width: '100%',
        background: theme.palette.common.white,
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    },
    placeholderIcon: {
        opacity: ".2",
        width: "5rem",
        height: "5rem"
    },
    imageVisible: {
        opacity: 1
    },
    conditionReport: {
        marginRight: "2rem",
        color: theme.palette.error.main
    },
    spinner: {
        position: 'absolute',
        top: '50%',
        left: 'calc(50% + 100px)',
        zIndex: '100'
    },
    activityLogContainer: {
        maxWidth: 1300
    },
    activityLogHeader: {
        color: theme.palette.primary.main,
    },
    dateHeader: {
        width: 150
    },
    cardMobile: {
        padding: "1rem"
    },
    titleMobile: {
        fontSize: 16
    },
    titleRowMobile: {
        marginBottom: 0
    },
    detailsMobile: {
        "&:not(:last-child)": {
            marginBottom: "8px"
        }
    },
    detailMobile: {
        width: "100%",
        "&:not(:first-child)": {
            paddingLeft: 8,
            "&::before": {
                display: "none"
            }
        },
    },
    imageMobile: {
        width: "100%"
    },
    imageContainerMobile: {
        width: "auto",
        minHeight: 160,
        marginRight: 0
    },
    noAssetDiv: {
        backgroundColor: theme.palette.common.white,
        width: '100%',
        display: 'flex',
        justifyContent: 'center'
    },
    placeholderDetail: {
        minWidth: '290px'
    },
    exportButtonWrapper: {
        marginLeft: 'auto'
    },
    input: {
        marginTop: 16
    },
    editButton: {
        paddingLeft: 60,
        paddingRight: 60
    },
    docTitle: {
        fontWeight: 600,
        padding: '0.5em 0'
    },
    dateWrapper: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"
    },
    commentContainer: {
        marginBottom: 20
    },
    pageTitleWrapper: {
        marginBottom: theme.spacing(2),
        position: 'sticky',
        top: theme.mixins.toolbar.minHeight ?? 64,
        zIndex: theme.zIndex.appBar - 1,
        backgroundColor: theme.palette.common.white,
        borderRadius: theme.shape.borderRadius,
        boxShadow: theme.shadows[1],
        padding: theme.spacing(2),
    },
    pageTitleRow: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1.5),
        marginBottom: theme.spacing(0.5),
    },
    pageTitle: {
        fontSize: 26,
        fontWeight: 600,
        color: theme.typography.color,
        margin: 0,
    },
    statusBadge: {
        border: `1px solid ${theme.palette.warning.main}`,
        color: theme.palette.warning.dark,
        borderRadius: 20,
        padding: `${theme.spacing(0.25)}px ${theme.spacing(1.25)}px`,
        fontSize: 12,
        fontWeight: 500,
        display: 'inline-flex',
        alignItems: 'center',
    },
    sectionTitle: {
        fontSize: '1.5em',
        fontWeight: 500,
    },
    header: {
        marginBottom: '0.5rem',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    typeIcon: {
        '& svg': {
            width: '2em',
            height: '2em',
        }
    },
    activityName: {
        fontWeight: 500,
        fontSize: 20
    },
    status: {
        display: 'flex',
        alignItems: 'center'
    },
    statusControl: {
        display: 'inline-flex',
        minWidth: 0,
        maxWidth: '100%',
        '& .MuiInputBase-root': {
            fontSize: 14,
        },
    },
    statusItem: {
        cursor: 'pointer',
        alignItems: "center",
        justifyContent: "space-between"
    },
    selectItem: {
        padding: '0.5em 1em',
        '&.filled': {
            paddingLeft: '0.5em'
        }
    },
    select: {
        fontSize: '1em',
        padding: 0,
        borderRadius: 0,
        '& :hover': {
            backgroundColor: theme.palette.grey[100]
        },
        '& fieldset': {
            border: 'none',
        },
        '& .MuiSelect-icon': {
            fill: 'black',
            width: '20px'
        }
    },
    formBtn: {
        width: '150px',
    },
    detailsGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(170px, 1fr))',
        gap: theme.spacing(2),
        alignItems: 'start',
    },
    detailCell: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(0.25),
        minWidth: 0,
    },
    detailCellRowStart: {
        gridColumnStart: 1,
    },
    detailCellLabel: {
        fontSize: 12,
        color: theme.palette.text.secondary,
    },
    detailCellValue: {
        fontSize: 14,
        fontWeight: 600,
        color: theme.typography.color,
        wordBreak: 'break-word',
    }
}));
